import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkPolicyHolderIdGreaterThan1000Rule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const policyHolderId = control.get('policyHolderId')!.value;
	return !!policyHolderId && ((!isNaN(policyHolderId) && Number(policyHolderId) < 1001)  || isNaN(policyHolderId))
	              ? { checkPolicyHolderIdGreaterThan1000Flag: true } : null;
};
